import { IDataWidget } from '../redux/timeline-data.model';
import { Widget } from './Widget';
import { TrackElement } from './TrackElement'; // NB imports TimedWidget!

class TimedWidget extends Widget {

	private _trackElement: TrackElement;

	constructor( data: IDataWidget ) {
		super( data );
	}

	get trackElement(): TrackElement {
		return this._trackElement;
	}

	set trackElement( trackElement: TrackElement ) {
		this._trackElement = trackElement;
	}
}

export{ TimedWidget };
